import React, { FC, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router';
import { PageLoading } from 'components/atoms/loading';
import { computeThemeMapping } from 'components/organisms/templates/forms/form-builder/themes/color-themes-list';
import { DEFAULT_CUSTOM_COLOR_CODE } from 'components/organisms/templates/forms/form-builder/themes/constants';
import { useAccount } from 'hooks/use-account';
import { useTranslation } from 'hooks/use-translation';
import { useCreateFormTemplate } from 'queries/form-template';

export const NewFormTemplatePage: FC = () => {
  const history = useHistory();
  const pageTitle = useTranslation('loading');
  const { mutate } = useCreateFormTemplate();
  const {
    metaData: { theme },
  } = useAccount();

  useEffect(() => {
    const defaultFormThemeColors = theme?.brandColor
      ? computeThemeMapping(theme.brandColor)
      : computeThemeMapping(DEFAULT_CUSTOM_COLOR_CODE);

    mutate(
      {
        name: 'Untitled form',
        formSettings: {
          formResponseType: 'SINGLE_RESPONSE',
          formSharing: 'RESTRICTED',
        },
        formTheme: {
          ...defaultFormThemeColors,
          brightness: 30,
        },
      },
      {
        onSuccess: (data) => {
          history.replace(`/templates/forms/${data.templateId}`);
        },
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <PageLoading />
    </>
  );
};
